import React from 'react'
import Button from '../Button/Button'
import styles from './Unauthorized.module.scss'
import banner from '../../assets/images/static-banner.png'
import { useSelector } from 'react-redux'

function Unauthorized() {
  const siteSetting = useSelector(state => state.site)
  return (
    <section style={{ background: `url(${siteSetting.bannerImage ?? banner})` }} className={styles._404}>
      <div className="container">
        <h1>Unauthorized!</h1>
        <p className={styles.cnt}>Sorry, You are not authorized to view this Resource!</p>
        <Button className={styles.btn} to='/'>Go to Home</Button>
      </div>
    </section>
  )
}

export default Unauthorized
